/** Decodes one base64url segment of a JWT. Throws on anything that is not valid base64. */
function decodeBase64UrlSegment(segment: string): string {
  const base64 = segment.replace(/-/g, "+").replace(/_/g, "/");
  return atob(base64.padEnd(Math.ceil(base64.length / 4) * 4, "="));
}

/**
 * The org id carried in a Slack OAuth `state` token, or `undefined` when the token is
 * malformed or names no org.
 *
 * This is NOT a security check: the signature is not verified here, and the value must not be
 * treated as proof of anything. It only routes the exchange to the org that started the
 * install, rather than to whichever org the document handling the redirect happens to consider
 * current. The service re-reads the token, verifies its signature, and enforces org-admin
 * rights on the org it recovers.
 */
export function orgFromStateToken(state: string): string | undefined {
  const payload = state.split(".")[1];
  if (payload === undefined || payload === "") {
    return undefined;
  }
  try {
    const claims: unknown = JSON.parse(decodeBase64UrlSegment(payload));
    if (typeof claims !== "object" || claims === null) {
      return undefined;
    }
    const org = (claims as { org?: unknown }).org;
    return typeof org === "string" && org !== "" ? org : undefined;
  } catch {
    return undefined;
  }
}
